module.exports = __webpack_public_path__ + "static/media/icons8Bank.847c6649.svg";